import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { HotelManagementService } from '../../../shared/_services/hotel-management.service';
import { MarketingService } from '../../../shared/_services/marketing.service';

@Component({
    selector: 'app-status-modal',
    templateUrl: './status-modal.component.html',
    styleUrls: ['./status-modal.component.scss']
})

export class StatusModalComponent implements OnInit {
    srcObject: any = [];
    duplicatedValue: any = "";   
    constructor(public bsModalRef: BsModalRef,
        private router: Router,
        private hotelManagementService: HotelManagementService,
        private marketingService: MarketingService,
    ) { }

    confirmClose() {
        if (this.bsModalRef.content.srcObject.type == "hca-wizard") {
            this.srcObject.action = "action2";
        }
        this.bsModalRef.hide();
    }

    action1() {
        // if (this.bsModalRef.content.srcObject.type == "hca-brand"
        //     || this.bsModalRef.content.srcObject.type == "hca-image"
        //     || this.bsModalRef.content.srcObject.type == "hca-wizard"
        //     || this.bsModalRef.content.srcObject.type == "hca-remove"
        //     || this.bsModalRef.content.srcObject.type == "hca-discard"
        //     || this.bsModalRef.content.srcObject.type == "hotel-add"
        //     || this.bsModalRef.content.srcObject.type == 'catalog'
        //     || this.bsModalRef.content.srcObject.type == "reward-list"
        //     || this.bsModalRef.content.srcObject.type == "promo-list"
        //     || this.bsModalRef.content.srcObject.type == "member-list"
        //     || this.bsModalRef.content.srcObject.type == "email-list"
        //     || this.bsModalRef.content.srcObject.type == "booking-list"
        //     || this.bsModalRef.content.srcObject.type == "reward-list-new"
        //     || this.bsModalRef.content.srcObject.type == "promo-list-new"
        //     || this.bsModalRef.content.srcObject.type == 'reward-add'
        //     || this.bsModalRef.content.srcObject.type == 'catalog-modal'
        //     || this.bsModalRef.content.srcObject.type == 'hotel-list'
        //     || this.bsModalRef.content.srcObject.type == 'promo-add'
        //     || this.bsModalRef.content.srcObject.type == 'member-edit'
        //     || this.bsModalRef.content.srcObject.type == 'cart-edit'
        //     || this.bsModalRef.content.srcObject.type == 'hca-header-footer'
        //     || this.bsModalRef.content.srcObject.type == 'hca-hero-banner'
        //     || this.bsModalRef.content.srcObject.type == 'hca-catalog-banner'
        //     || this.bsModalRef.content.srcObject.type == 'hca-next-step'
        //     || this.bsModalRef.content.srcObject.type == 'hca-other-pages'
        //    ) {
            if(this.bsModalRef.content.srcObject.type) {
            this.srcObject.action = "action1";
            this.srcObject.duplicatedEmailId = this.duplicatedValue.trim().toLowerCase();
            this.bsModalRef.hide();
            //this.bsModalRef = null;
        }
    }
    ngOnInit() {
        // console.log(this.srcObject);       
        // console.log(this.bsModalRef);
    }
    //Removes leading and trailing spaces and multiple spaces with one space 
  trimText(el) {    
    if (el.target.value != undefined) {
        let targetValue = el.target.value;
         el.target.value = targetValue.trim();      
         this.duplicatedValue = el.target.value;         
        return;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/modals/status-modal/status-modal.component.ts